import { render, staticRenderFns } from "./BookingEditPage.vue?vue&type=template&id=3b396714&scoped=true&"
import script from "./BookingEditPage.vue?vue&type=script&lang=js&"
export * from "./BookingEditPage.vue?vue&type=script&lang=js&"
import style0 from "./BookingEditPage.vue?vue&type=style&index=0&id=3b396714&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b396714",
  null
  
)

export default component.exports